export const environment = {
  production: false,
  apiUrl: 'https://api-uat.getpass.ph',
  database: 'getransport',
  userName: 'jayson@getevee.com',
  password: 'DP28QFpPYJEtXZFL'
};
